export default {

    /**
     * All methods should have a prefix of the filename. i.e. genericLocalStorage
     */
    methods: {

        genericLocalStorageSupportsLocalStorage() {

            if (typeof Storage !== "undefined") {
                return true;
            } else {
                // FIXME: REMOVE THIS
                console.log('Local storage is not supported by this browser.');
                return false;
            }

        },

        async genericLocalStorageGetItem(key, defaultValue = false) {

            let self = this;

            return new Promise(function (resolve) {
                if (key in localStorage) {

                    resolve(JSON.parse(localStorage.getItem(key)));
                } else {

                    if (defaultValue) {
                        self.genericLocalStorageSetItem(key, defaultValue)
                        resolve(defaultValue);
                    }

                }
                resolve([])
            });

        },

        genericLocalStorageSetItem(key, item) {
            localStorage.setItem(key, JSON.stringify(item))
        },

        genericLocalStorageRemoveItem(key) {
            localStorage.removeItem(key)
        },

        genericLocalStorageClear() {
            localStorage.clear()
        },

        genericLocalStorageHasItem(key) {
            return key in localStorage
        }


    }

}
